<div class="container">
  <div>

    <h1>{{ 'about.title' | t }}</h1>


    <br>
    <h2>{{ 'about.whoWeAre' | t }}</h2>
    <p>
      {{ 'about.intro' | t }}
    </p>

    <h3>{{ 'about.heading1' | t }}</h3>
    <p>
      {{ 'about.text1' | t }}
    </p>

    <h3>{{ 'about.heading2' | t }}</h3>
    <p>
      {{ 'about.text2' | t }}
    </p>

  </div>
</div>